// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"488":"4838854c","746":"4838854c"}[chunkId] + ".css";
};